"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToggleButtonGroup = void 0;
var core_1 = require("@material-ui/core");
var styled_components_1 = __importDefault(require("styled-components"));
var lab_1 = require("@material-ui/lab");
exports.StyledToggleButtonGroup = core_1.withTheme(styled_components_1.default(lab_1.ToggleButtonGroup)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    display: flex;\n    justify-content: center;\n\n    button {\n        flex-basis: 30%;\n        background-color: ", ";\n        color: ", ";\n\n        &:hover {\n            background-color: ", ";\n            color: ", ";\n        }\n        &.Mui-selected {\n            background-color: ", ";\n            color: ", ";\n        }\n        &.Mui-selected:hover {\n            background-color: ", ";\n            color: ", ";\n        }\n    }\n"], ["\n    width: 100%;\n    display: flex;\n    justify-content: center;\n\n    button {\n        flex-basis: 30%;\n        background-color: ", ";\n        color: ", ";\n\n        &:hover {\n            background-color: ", ";\n            color: ", ";\n        }\n        &.Mui-selected {\n            background-color: ", ";\n            color: ", ";\n        }\n        &.Mui-selected:hover {\n            background-color: ", ";\n            color: ", ";\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.variables.palette.crypto.toggleButtons.mainBackground;
}, function (_a) {
    var theme = _a.theme;
    return theme.variables.palette.crypto.toggleButtons.mainColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.variables.palette.crypto.toggleButtons.hoverBackground;
}, function (_a) {
    var theme = _a.theme;
    return theme.variables.palette.crypto.toggleButtons.hoverColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.variables.palette.crypto.toggleButtons.hoverBackground;
}, function (_a) {
    var theme = _a.theme;
    return theme.variables.palette.crypto.toggleButtons.hoverColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.variables.palette.crypto.toggleButtons.hoverBackground;
}, function (_a) {
    var theme = _a.theme;
    return theme.variables.palette.crypto.toggleButtons.hoverColor;
}));
var templateObject_1;
